<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  components: {
  },
  created() {
    this.$store.dispatch('loadWatercourses');
  }
};
</script>

<style lang="scss">
  @import './assets/sass/app.scss';
</style>
